import { defineMessages } from "react-intl";

export const scope =
  "pages.IntroducingBrokerSingleMemberPage.components.TotalBalanceLocalMarketCard";

export const messages = defineMessages({
  totalBalance: {
    id: `${scope}.totalBalance`,
    defaultMessage: "Saldo Mercado Local",
  },
  accountNotCreated: {
    id: `${scope}.accountNotCreated`,
    defaultMessage: "Cuenta no creada",
  },
  buttonHistory: {
    id: `${scope}.buttonHistory`,
    defaultMessage: "Ver Historial",
  },
  buttonDetail: {
    id: `${scope}.buttonDetail`,
    defaultMessage: "Ver Detalle",
  },
});
